import React from "react";
import "./PieDePagina.css";
import { useTranslation } from "react-i18next";
import { FaLinkedin, FaInstagram, FaFacebook } from "react-icons/fa";

export default function PieDePagina() {
  const { t } = useTranslation();
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-top-grid">
          <div className="footer-col footer-col-1">
            <div className="footer-block footer-socials">
              <strong>{t("footer.social_networks")}</strong>
              <div className="social-icons">
                <a
                  href="https://www.linkedin.com/company/consultoria-global-s-a-"
                  title="Consultoría Global S.A. - LinkedIn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaLinkedin />
                </a>
                <a
                  href="https://www.instagram.com/consultoria_global/"
                  title="Consultoría Global (@consultoria_global) - Instagram profile"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaInstagram />
                </a>
                <a
                  href="https://www.facebook.com/ConsultoriaGlobalSA/"
                  title="Consultoría Global S.A. | Buenos Aires"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {/* URL de Facebook provisoria */}
                  <FaFacebook />
                </a>
              </div>
            </div>
          </div>

          <div className="footer-col footer-col-2">
            <div className="footer-block">
              <strong>{t("sedes.argentina.pais")}</strong>
              {t("sedes.argentina.direccion")?.split("\n").map((line, index) => (
                <div key={index}>{line}</div>
              ))}
            </div>
          </div>

          <div className="footer-col footer-col-3">
            <div className="footer-block">
              <strong>{t("sedes.espana.pais")}</strong>
              {t("sedes.espana.direccion")?.split("\n").map((line, index) => (
                <div key={index}>{line}</div>
              ))}
            </div>
          </div>

          <div className="footer-col footer-col-4">
            <div className="footer-block">
              <strong>{t("sedes.chile.pais")}</strong>
              {t("sedes.chile.direccion")?.split("\n").map((line, index) => (
                <div key={index}>{line}</div>
              ))}
            </div>
          </div>

          <div className="footer-col footer-col-5">
            <div className="footer-contact-info">
              <strong>{t("footer.contact")}</strong>
              <div>+ 54 11 5219 4733</div>
              <div>+ 54 11 3988 6104</div>
            </div>
          </div>
        </div>

        <div className="footer-bottom-grid">
          <div className="footer-bottom-left">
            <div className="footer-data-fiscal">
              <strong>{t("footer.data_fiscal")}</strong>
              <div className="data-fiscal-container">
                <a href="http://qr.afip.gob.ar/?qr=ItHVrtjHdz4tjHIftVnZ4A,," target="_F960AFIPInfo" rel="noopener noreferrer">
                  <img src="/DATAWEB.jpg" alt="DATA FISCAL" className="data-fiscal-img" />
                </a>
              </div>
            </div>
          </div>
          <div className="footer-bottom-center">
            <div className="footer-copy">{t("footer.copy", { year: new Date().getFullYear() })}</div>
          </div>
          <div className="footer-bottom-right">
            <div className="footer-policy-section">
              <h4 className="footer-policy-title">{t("footer.policy_title")}</h4>
              <div className="footer-policy-logos">
                <a
                  href="/Politica_Seguridad_de_la_Informacion_CG.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-download-link"
                >
                  {t("footer.download") || "Descargar"}
                </a>
                <img
                  src="./certificacion.svg"
                  alt={t("alt.pdf_logo") || "Certificaciones CML e IQNet"}
                  className="footer-policy-img"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
